// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bwR4","placeholdersHeader":"styles_placeholdersHeader__1V0ms","editorStyle":"styles_editorStyle__3onHV","placeholdersBox":"styles_placeholdersBox__gVNaG"};